import { CategoryTree } from '@/fo/api/magento';

import { BRAND_CATEGORY_PATHS } from '../constants';

export const isBrandCategoryPage = (
  category?: CategoryTree | null
): boolean => {
  if (!category?.url_path) {
    return false;
  }

  return BRAND_CATEGORY_PATHS.some((brandPath) =>
    category.url_path?.startsWith(brandPath)
  );
};
